import { IMXCheckoutContext } from '@/context/IMXCheckoutProvider';
import { useContext } from 'react';

export const useIMXCheckout = () => {
  const context = useContext(IMXCheckoutContext);
  return context;
};
